import { useEffect } from 'react';
import {
  useSharedValue,
  useAnimatedStyle,
  withSequence,
  withTiming,
} from 'react-native-reanimated';

import { animation } from '../tokens';

export function useWrongShake(trigger: boolean) {
  const translateX = useSharedValue(0);

  useEffect(() => {
    if (trigger) {
      const d = animation.quick / 2;
      translateX.value = withSequence(
        withTiming(-6, { duration: d }),
        withTiming(6, { duration: d }),
        withTiming(-4, { duration: d }),
        withTiming(4, { duration: d }),
        withTiming(0, { duration: d }),
      );
    }
  }, [trigger, translateX]);

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [{ translateX: translateX.value }],
  }));

  return animatedStyle;
}
